import { SelectedAssignablesEffects } from "./selected-assignables.effect";

// so we can just have one import in districts.module
export const effects: any[] = [SelectedAssignablesEffects];

export * from "./selected-assignables.effect";
